import 'css-chunksrc/client/app/router/routeLoader/styles.scss';export default {
  "routeLoader": "_routeLoader_piup7_1",
  "loader": "_loader_piup7_9"
};